var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.open}},[_vm._v("主要按钮")])
}
var staticRenderFns = []

export { render, staticRenderFns }